/*
    a Hook to retreive and store queries user searches in the search-suggestion component
*/
import { useCookies } from 'react-cookie'

import { useMemo } from 'react'

import { SearchItemWithImageViewModel } from '@/types/api'

import { generateSearchUrl } from './search-helpers'

import { SEARCH_HISTORY_LOCAL_KEY, SEARCH_HISTORY_MAX_ITEMS } from '../constants'

export default function useSearchHistory(): [SearchItemWithImageViewModel[] | null, (item: string) => void] {
    const [cookies, setCookies] = useCookies<string, { [key: string]: string[] }>([SEARCH_HISTORY_LOCAL_KEY])

    const addItem = (item: string) => {
        const items = cookies?.[SEARCH_HISTORY_LOCAL_KEY] || []

        // if is duplicate, don't add
        if (items.includes(item)) {
            items.splice(items.indexOf(item), 1)
        }

        setCookies(SEARCH_HISTORY_LOCAL_KEY, [item, ...items].slice(0, SEARCH_HISTORY_MAX_ITEMS))
    }

    const populatedItems: SearchItemWithImageViewModel[] | null = useMemo(() => {
        const items = cookies?.[SEARCH_HISTORY_LOCAL_KEY] || []

        return items.length
            ? items.map((item, index) => ({ id: `${index}`, nameFa: item, slug: generateSearchUrl(item) }))
            : null
    }, [cookies])

    return [populatedItems, addItem]
}
